import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import PhoneAppResource from './PhoneAppResource';
import ServiceProviderTypeAppResource from './ServiceProviderTypeAppResource';
import UserAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/UserAppResource";
import Engine from '@milestoneslabs/milestones-js-engine';

export const USER_PROFESSIONAL = 'userProfessional';

class ServiceProviderUserProfessionalAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'service-provider-user-professional';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'services/providers/users/professionals';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'userUuid',
            'categoryUuid',
            'name',
            'companyName',
            'phoneUuid',
            'email',
            'website',
            'phone',
            'category',
            'user',
            'projectTypes',
            'isVisible',
        ];
    }

    apiPaths () {
        return {
            ...super.apiPaths(),
            'elasticsearch': Engine.apiUrl(this.appResourceApiPrefix()) + '/search/elastic',
        }
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            phone: PhoneAppResource,
            category: ServiceProviderTypeAppResource,
            user: UserAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            phone: 'phone_uuid',
            category: 'category_uuid',
            user: 'user_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            categoryUuid: {
                type: 'string',
                presence: {
                    allowEmpty: false,
                    message: "^Category can't be blank"
                },
            },
            name: function (value, attributes, attributeName, options, constraints) {
                if (attributes?.companyName?.replaceAll(/\s/g, '')) {
                    return null;
                }
                return {
                    type: 'string',
                    length: {
                        maximum: 100,
                        minimum: 2,
                    },
                    presence: {
                        allowEmpty: false,
                        message: "^Name or Company name is required"
                    },
                }
            },
            companyName: function (value, attributes, attributeName, options, constraints) {
                if (attributes?.name?.replaceAll(/\s/g, '')) {
                    return null;
                }
                return {
                    type: 'string',
                    length: {
                        maximum: 100,
                        minimum: 2,
                    },
                    presence: {
                        allowEmpty: false,
                        message: "^Name or Company name is required"
                    },
                }
            },
            userUuid: {
                type: 'string',
            },
            phoneUuid: {
                type: 'string'
            },
            website: {
                type: 'string',
                format: {
                    pattern: '^$|[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+-~#=]{2,256}\\.[a-z]{2,}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=\']*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 255,
                },
            },
            email: {
                type: 'string',
                email: true,
                length: {
                    maximum: 255,
                },
            },
            isVisible: {
                type: 'boolean',
            },
        };
    }
}

export default ServiceProviderUserProfessionalAppResource;
